import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const ProjectSelect = ({ value, onChange, projects, disabled, showAllOption = false }) => (
  <FormControl fullWidth margin="dense" disabled={disabled} variant="outlined">
    <InputLabel id="project-select-label" shrink={!!value}>Проект</InputLabel>
    <Select
      labelId="project-select-label"
      value={value || ''}
      label="Проект"
      onChange={e => onChange(e.target.value)}
      MenuProps={{ 
        PaperProps: { style: { maxHeight: 300 } },
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' }
      }}
    >
      {showAllOption && <MenuItem value="">Все</MenuItem>}
      {projects.map((project) => (
        <MenuItem key={project.id} value={project.id}>{project.name}</MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default ProjectSelect;
